
export enum GliderFileType  {
  gli ='gli',
  pld1 = 'pld1',
  pld2 = 'pld2',
  ad2cp = 'ad2cp'
}